// extracted by mini-css-extract-plugin
export default {"container":"QualityMeasures_container__o8y4Q","box":"QualityMeasures_box__WMIBH","container2":"QualityMeasures_container2__QqNgQ","box2":"QualityMeasures_box2__yg+bO"};